import { useEffect } from 'react';
import Header from '../components/Header';
import Hero from '../components/sections/Hero';
import ValueProps from '../components/sections/ValueProps';
import Services from '../components/sections/Services';
import About from '../components/sections/About';
import WhyUs from '../components/sections/WhyUs';
import Partners from '../components/sections/Partners';
import Testimonials from '../components/sections/Testimonials';
import FAQ from '../components/sections/FAQ';
import ContactCTA from '../components/sections/ContactCTA';
import Map from '../components/sections/Map';
import Footer from '../components/Footer';
import MobileCallBar from '../components/MobileCallBar';

export default function Landing() {
  useEffect(() => {
    // Smooth in-page anchor scrolling
    const handler = (e) => {
      const target = e.target.closest('a[href^="#"]');
      if (!target) return;
      const id = target.getAttribute('href');
      if (id && id.length > 1) {
        const el = document.querySelector(id);
        if (el) {
          e.preventDefault();
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    };
    document.addEventListener('click', handler);
    return () => document.removeEventListener('click', handler);
  }, []);

  return (
    <>
      <Header />
      <main>
        <Hero />
        <ValueProps />
        <Services />
        <About />
        <WhyUs />
        <Partners />
        <Testimonials />
        <FAQ />
        <ContactCTA />
        <Map />
      </main>
      <Footer />
      <div className="lg:hidden h-14" aria-hidden="true" />
      <MobileCallBar />
    </>
  );
}
